import { app_version } from './version';
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
	production: false
};

export const oase_config = {
	auth_token: {
		name: 'authtoken'
	},
	singlecompany: true, // ist zu setzen wenn es nur eine firma gibt
	defaultyappid: 'oase', // ist zu setzen wenn es nur eine firma gibt
	loggedinuser: 'loggedinuser',
	iscopydialogopend: 'iscopydialogopend',
	isaddingtocopyallowed: 'isaddingtocopyallowed',
	sessiondata: {
		name: 'at.oase.lisweb.sessiondata'
	},
	restapi: {
		dev: {
			schema: 'https',
			host: 'liswebtest.kaerntnermilch.at',
			port: '',
			path: 'lisweb',
		},
		prod: {
			schema: 'https',
			host: 'lisweb.kaerntnermilch.at',
			port: '',
			path: 'lisweb',
		}
	},
	appversion: app_version,
	rights: {
		superadmin: 'recht.superadmin',
		allebenutzergruppen: 'recht.bearbeiten.gruppen.benutzer.alle',
		zugeordnetebenutzergruppen: 'recht.bearbeiten.gruppen.benutzer.zugeordnet',
		allesichtgruppen: 'recht.bearbeiten.gruppen.sicht.alle',
		zugeordnetesichtgruppen: 'recht.bearbeiten.gruppen.sicht.zugeordnet',
		allenutzergruppen: 'recht.bearbeiten.gruppen.nutzer.alle',
		zugeordnetenutzergruppen: 'recht.bearbeiten.gruppen.nutzer.zugeordnet',
		allestatistikgruppen: 'recht.bearbeiten.gruppen.statistik.alle',
		zugeordnetestatistikgruppen: 'recht.bearbeiten.gruppen.statistik.zugeordnet'
	}
};


// import { app_version } from './version';
// // The file contents for the current environment will overwrite these during build.
// // The build system defaults to the dev environment which uses `environment.ts`, but if you do
// // `ng build --env=prod` then `environment.prod.ts` will be used instead.
// // The list of which env maps to which file can be found in `angular-cli.json`.
//
// export const environment = {
//   production: false
// };
//
// export const oase_config = {
//   auth_token: {
//     name: 'authtoken'
//   },
//   loggedinuser: 'loggedinuser',
//   iscopydialogopend: 'iscopydialogopend',
//   isaddingtocopyallowed: 'isaddingtocopyallowed',
//   sessiondata: {
//     name: 'at.oase.lisweb.sessiondata'
//   },
//   restapi: {
//     schema: 'http',
//     host: 'localhost',
//     port: '8080',
//     path: 'lisweb'
//   },
//   appversion: app_version
// };
